<template>
    <b-row key="datos-comprador" id="datos-comprador">
        <b-col sm="12">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row>
                    <b-col sm="12" md="6">
                        <FormInput
                            v-model="datos_comprador.nombre"
                            id="nombre"
                            rules="required"
                            :label="$t('formularios.nombre')"
                            :name="$t('formularios.nombre')"
                        />
                    </b-col>
                    <b-col sm="12" md="6">
                        <FormInput
                            v-model="datos_comprador.apellido"
                            id="apellidos"
                            rules="required"
                            :label="$t('formularios.apellidos')"
                            :name="$t('formularios.apellidos')"
                        />
                    </b-col>
                    <b-col sm="12" md="6">
                        <FormInput
                            v-model="datos_comprador.edad"
                            id="edad"
                            rules="required"
                            :label="$t('formularios.edad')"
                            :name="$t('formularios.edad')"
                            :apiValidationError="apiErrors.edad"
                        />
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <label class="mb-3">{{ $t('formularios.telefono') }}</label>
                            <PhoneInput
                                :phone="datos_comprador.telefono ?? null"
                                @setNumber="(number) => datos_comprador.telefono = number"
                                @validNumber="(valid) => isValidNumber = valid"
                            />
                        </div>
                    </b-col>
                    <b-col sm="12" md="6">
                        <FormInput
                            v-model="datos_comprador.cp"
                            id="cp"
                            rules="required"
                            :label="$t('formularios.cp')"
                            :name="$t('formularios.cp')"
                            :apiValidationError="apiErrors.cp"
                        />
                    </b-col>
                    <b-col sm="12" md="6">
                        <DocumentoTipo
                            v-model="datos_comprador.tipoDocumento"
                            :index="0"
                        />
                    </b-col>
                    <b-col sm="12" md="6">
                        <DocumentoValor
                            v-model="datos_comprador.dni"
                            :type="datos_comprador.tipoDocumento"
                            :index="0"
                        />
                    </b-col>
                    <b-col sm="12" md="6">
                        <FormInput
                            v-model="datos_comprador.email"
                            id="email"
                            vid="confirmation"
                            rules="required|email"
                            :label="$t('formularios.email')"
                            :name="$t('formularios.email')"
                            :apiValidationError="apiErrors.email"
                        />
                    </b-col>
                    <b-col sm="12" md="6">
                        <FormInput
                            v-model="datos_comprador.confirmar_email"
                            id="email_confirmation"
                            :rules="'required|confirmed_ci:@confirmation'"
                            :label="$t('formularios.confirmar_email')"
                            :name="$t('formularios.confirmar_email')"
                            :apiValidationError="apiErrors.email_confirmation"
                        />
                    </b-col>
                    <b-col cols="12">
                        <p>{{ $t('parcelas.email_informacion') }}</p>
                    </b-col>
                    <b-col cols="12" class="mt-2" v-for="(parcela, index) in datosParcelas" :key="index">
                        <label for="precio">{{ $t('parcelas.precio_parcela') + ' Nº ' + parcela.numero }}</label>
                        <ValidationProvider
                            :name="$t('parcelas.precio_parcela') + ' Nº ' + ++index"
                            rules="required"
                            mode="passive"
                            v-slot="{ errors }"
                        >
                            <multiselect
                                v-model="parcela.precioSeleccionado"
                                label="descripcion"
                                :show-labels="false"
                                :options="parcela.precios"
                                :allow-empty="false"
                                :custom-label="customLabel"
                                :class="'form-control custom-width ' + (errors[0] ? 'is-invalid' : '')"
                            />
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" class="mt-3 d-flex justify-content-end flex-wrap">
                        <button
                            id="compra-responsive"
                            type="submit"
                            :class="['button', 'effect-button', { 'large-button': !esMovil }]"
                            :disabled="loading"
                        >
                            <span>{{ $t('partido.continuar') }}</span>
                        </button>

                        <button
                            id="atras"
                            type="button"
                            :disabled="loading"
                            :class="['button', 'effect-button', 'ml-2', 'compra-responsive', { 'large-button': !esMovil }]"
                            @click="$emit('cambiarAsiento')"
                        >
                            <span>{{ $t('formularios.atras') }}</span>
                        </button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </b-col>
    </b-row>
</template>

<script>
    import PhoneInput from '@/components/common/PhoneInput';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';

    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            datosComprador : {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                loading: false,
                datos_comprador: this.datosComprador || {},
                isValidNumber: false,
                apiErrors: {},
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid && this.isValidNumber) {
                    this.terminar();
                }
            },
            terminar() {
                this.loading = true;

                const params = {
                    cart_id: localStorage.getItem('cart_id'),
                    datos_compradores: [this.datos_comprador],
                    parcelas: this.datosParcelas.map(parcela => ({
                        id: parcela.id,
                        precio_id: parcela.precioSeleccionado.id
                    }))
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.guardar-datos-comprador'), params).then(res => {
                    this.$emit('terminado', res.data.jet_id, res.data.formulario);
                    this.$emit('datos_comprador', this.datos_comprador);
                }).catch(error => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        const errors = error.response.data.errors;
                        this.apiErrors = {};
                        for (const [field, messages] of Object.entries(errors)) {
                            const key = field.split('.').pop();
                            this.apiErrors[key] = messages[0];
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            customLabel({ descripcion, precio }) {
                return `${descripcion} – ${this.$n(precio, 'currency')}`
            },
        },
        computed: {
            esMovil() {
                return window.innerWidth < 768;
            }
        },
        components: {
            PhoneInput, DocumentoTipo, DocumentoValor
        },
        watch: {
            datos_comprador: {
                handler(newVal) {
                    this.$emit('updateDatosComprador', newVal);
                },
                deep: true
            }
        },
        created(){
            if (!this.datos_comprador.tipoDocumento) {
                this.$set(this.datos_comprador, 'tipoDocumento', 'DNI');
            }
        }
    }
</script>
